import React from 'react';
import clsx from 'clsx';
import defaultStyles from './__styles__/index.scss?modules';

const PartialShadowBox = ({ customStyles, children }) => {
  const styles = customStyles || defaultStyles;
  return (
    <div className={clsx(styles.shadowBoxOuter)}>
      <div className={styles.shadowBoxInner}>{children}</div>
    </div>
  );
};

export default React.memo(PartialShadowBox);
